import { z } from "zod";

import { type PricingType, pricingTypeSchema, responseErrorSchema, VisitType } from "../types";

// eslint-disable-next-line no-restricted-syntax
export enum TypeOfCare {
  HOME_HEALTH = "HOME_HEALTH",
  HOSPICE = "HOSPICE",
  PRIVATE_DUTY = "PRIVATE_DUTY",
}

export const accountPricingSchema = z.object({
  attributes: z.object({
    createdAt: z.string(),
    workplaceId: z.string(),
    visitType: z.nativeEnum(VisitType),
    agentReq: z.string(),
    payRateInMinorUnits: z.number().max(100_000),
    chargeRateInMinorUnits: z.number().max(100_000),
    pricingType: pricingTypeSchema,
    typeOfCare: z.nativeEnum(TypeOfCare),
  }),
  id: z.string(),
  type: z.literal("accountPricing"),
});
export type AccountPricing = z.infer<typeof accountPricingSchema>;

export const accountsPricingResponseSchema = z.object({
  data: z.array(accountPricingSchema),
  errors: z.array(responseErrorSchema).optional(),
});
export type AccountsPricingResponse = z.infer<typeof accountsPricingResponseSchema>;

export const createAccountPricingRequestSchema = z.object({
  data: z.object({
    attributes: accountPricingSchema.shape.attributes.omit({
      createdAt: true,
      workplaceId: true,
    }),
    type: accountPricingSchema.shape.type,
  }),
});
export type CreateAccountPricingRequest = z.infer<typeof createAccountPricingRequestSchema>;

export const accountPricingResponseSchema = z.object({
  data: accountPricingSchema,
  errors: z.array(responseErrorSchema).optional(),
});
export type AccountPricingResponse = z.infer<typeof accountPricingResponseSchema>;

export const updateAccountPricingRequestSchema = z.object({
  data: z.object({
    attributes: accountPricingSchema.shape.attributes
      .omit({
        createdAt: true,
        workplaceId: true,
      })
      .deepPartial(),
    id: z.string(),
    type: accountPricingSchema.shape.type,
  }),
});
export type UpdateAccountPricingRequest = z.infer<typeof updateAccountPricingRequestSchema>;

export const deleteAccountPricingRequestSchema = z.string();

export interface CreateHhaFormInputs {
  id?: string;
  visitType: VisitType;
  agentReq: string;
  payRateInDollar: number;
  chargeRateInDollar: number;
  pricingType: PricingType;
  typeOfCare: TypeOfCare;
}
